<template>
  <div class="chart-box" ref="chartBox" :style="getChartStyle" @click.stop="outClick">
    <v-chart
      v-if="showChart"
      class="chart"
      @click="dispatchEventCallback('click', $event)"
      @dblclick="dispatchEventCallback('dblclick', $event)"
      @mouseover="dispatchEventCallback('mouseover', $event)"
      @mouseout="dispatchEventCallback('mouseout', $event)"
      @mouseup="dispatchEventCallback('mouseup', $event)"
      @mousedown="dispatchEventCallback('mousedown', $event)"
      @touchstart="dispatchEventCallback('touchstart', $event)"
      @touchend="dispatchEventCallback('touchend', $event)"
      :option="option"
      ref="map"
      theme="ovilia-green"
      autoresize
    />
    <div
      class="visualMapExample"
      :style="getVisualMapExampleStyle"
      v-if="showHotExample && chartOption.showLines"
    >
      <!-- 水平 -->
      <div v-show="VisualMapExampleOrient == 'horizontal'">
        <!-- 连续 -->
        <div v-show="VisualMapExampleType == 'continuous'" class="verticallyCenter horConBox">
          <span class="visualMapTxt">最小值</span>
          <span class="numberAndAngle minNumber" v-show="VisualMapExampleText">
            <span>{{ VisualMapMin }}</span>
          </span>
          <span class="centerLineBox">
            <span class="left-angle" :style="leftAngleStyle" v-show="VisualMapExampleHandleIcon"></span>
            <span class="visualMapColor" :style="getVisualMapLineStyle"></span>
            <span class="right-angle" :style="rightAngleStyle" v-show="VisualMapExampleHandleIcon"></span>
          </span>
          <span class="numberAndAngle maxNumber" v-show="VisualMapExampleText">
            <span>{{ VisualMapMax }}</span>
          </span>
          <span class="visualMapTxt">最大值</span>
        </div>
        <!-- 分段 -->
        <div v-show="VisualMapExampleType == 'piecewise'" class="horPieBox pieColorBox">
          <div class="verticallyCenter pieColorItem" v-for="(item, index) in visualColorList" :key="index">
            <span class="color-module" :style="{ background: item.color }"></span>
            <span class="color-txt" v-show="VisualMapExampleText">{{ item.range }}</span>
          </div>
        </div>
      </div>
      <!-- 垂直 -->
      <div v-show="VisualMapExampleOrient == 'vertical'">
        <div v-show="VisualMapExampleType == 'continuous'" class="horVerBox">
          <span class="visualMapTxt">最小值</span>
          <span class="numberAndAngle minNumber" v-show="VisualMapExampleText">
            {{ VisualMapMin }}
          </span>
          <span class="centerLineBox">
            <span class="left-angle" :style="leftAngleStyle" v-show="VisualMapExampleHandleIcon"></span>
            <span class="visualMapColor" :style="getVisualMapLineVerStyle"></span>
            <span class="right-angle" :style="rightVerAngleStyle" v-show="VisualMapExampleHandleIcon"></span>
          </span>
          <span class="numberAndAngle maxNumber" v-show="VisualMapExampleText">
            {{ VisualMapMax }}
          </span>
          <span class="visualMapTxt">最大值</span>
        </div>
        <div v-show="VisualMapExampleType == 'piecewise'" class="pieColorBox">
          <div class="verticallyCenter pieColorItem" v-for="(item, index) in visualColorList" :key="index">
            <span class="color-module" :style="{ background: item.color }"></span>
            <span class="color-txt" v-show="VisualMapExampleText">{{ item.range }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="tooltip-info height100"
      ref="tooltip1"
      v-if="chartOption.tooltip.show"
      :class="showTooltipDiv ? '' : 'opacity0'"
      :style="tooltipChartStyle"
    >
      <ul class="height100">
        <li v-for="item in list" :style="item.styleSet" class="floatLeft overflowHid">
          <div v-if="item.type === '1'">
            <img v-if="item.showIcon" :style="item.iconStyleSet" :src="item.iconImg" alt="" />
            <span :style="item.txtStyleSet">
              <span v-if="item.showLabel" :style="item.labelStyleSet">{{ item.name }}: </span>
              <span>{{ item.value }}</span>
              <span v-if="item.showUnit" :style="item.unitStyleSet">{{ item.unitValue }}</span>
            </span>
          </div>
          <div v-if="item.type === '2'">
            <img :style="item.styleSet1" :src="item.value" alt="" />
          </div>
        </li>
      </ul>
    </div>
    <div
      v-show="chartOption.tooltip.show && (chartOption.showScatter || chartOption.showHot) && !isBigScreenPreview()"
      class="tooltip-info-fix"
      :style="tooltipBgStyle"
    >
      <div :style="tooltipFixStyle" class="overflowHid">
        <ul class="height100" v-if="!tooltipAuto">
          <li v-for="item in list1" :style="item.styleSet" class="floatLeft overflowHid">
            <div v-if="item.type === '1'">
              <img v-if="item.showIcon" :style="item.iconStyleSet" :src="item.iconImg" alt="" />
              <span :style="item.txtStyleSet">
                <span v-if="item.showLabel" :style="item.labelStyleSet">{{ item.name }}: </span>
                <span>{{ item.value }}</span>
                <span v-if="item.showUnit" :style="item.unitStyleSet">{{ item.unitValue }}</span>
              </span>
            </div>
            <div v-if="item.type === '2'">
              <img :style="item.styleSet1" :src="item.value" alt="" />
            </div>
          </li>
        </ul>
        <div v-else>{{ tooltipAutoName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import deepMixin from "./deepMix.js"
import pluginMixin from "./plugin"
import eventMixin from "utils/event/eventMixin.js"
import handleChartData from "utils/updateData/chart/handleChartData.js"
import allChartDataHandle from "@/utils/updateData/chart/index.js"
import { chartOption1 } from "materials/bigScreen/map/menus/difference_options/allTypeCharOptions/chartOption1"
import { getSwData } from "utils/index.js"
import parentMixinCommon from "components/bigScreenComponents/common"
export default {
  name: "cxMap",
  mixins: [deepMixin, pluginMixin, eventMixin, handleChartData, parentMixinCommon],
  props: {
    options: {
      type: Object
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showChart: true,
      isFirst: true,
      stop: false,
      selfChangeData: false,
      mapName: "",
      created: false,
      option: {},
      eventCallbackList: {
        click: ["handleMapDeepEv", "handleMapLineChange", "handleMapScatterChange", "handleMapRegionEv"],
        mouseover: ["puTianShiTuShuGuanMapToolTip.mouseoverPuTianCity", "anKangBigData.mouseoverAnKangCity"],
        dblclick: [],
        mouseout: ["anKangBigData.mouseoutAnKangCity"],
        mouseup: [],
        mousedown: [],
        touchstart: [],
        touchend: []
      },
      out: false,
      reloadTimer: null,
      autoPlayToolTipTimer: null,
      tooltipIndex: 0,
      list: [],
      list1: [],
      tooltipDataLength: 0, //弹窗的数据长度
      showTooltipDiv: false,
      tooltipAuto: true,
      tooltipAutoName: "",
      hasMapJson: false,
      deepNewName: "",
      hasMapUrl: false,
      chinaMapAll: true,
      changeName: false
    }
  },
  watch: {
    "chartOption.name"(n, o) {
      this.hasMapJson = false
      this.changeName = true
      this.getAllMapDataLoop(n)
      this.initMapJson(n, true)
    },
    "chartOption.showHot"(n, o) {
      if (n && n !== o) {
        this.updateMapOptions(true)
      }else if(!n && n !== o){
        /*初次拖出来的地图，第一次打开热力，然后关掉，关不掉，再次重复后可以关掉*/
        this.stop = false
      }
    },
    "chartOption.showScatter"(n, o) {
      if (n && n !== o) {
        this.updateMapOptions(true)
      }else if(!n && n !== o){
        this.stop = false
      }
    },
    "chartOption.showLines"(n, o) {
      if (n && n !== o) {
        this.updateMapOptions(true)
      }else if(!n && n !== o){
        this.stop = false
      }
    },
    "chartOption.scatter.data": {
      deep: true,
      handler(n, o) {
        //当更换地区时 会触发当前watcher，但这个时候不需要执行当前watcher内的操作
        //这时 在更换地区的watcher（chartOption.name）中，会设置一个变量selfChangeData为true，且执行时机比当前watcher考前
        //在执行到当前watcher时 发先selfChangeData为true 说明不需要执行当前watcher内部的操作 则跳过 且将selfChangeData重置为false
        if (this.selfChangeData) {
          this.selfChangeData = false
        } else {
          this.stop = true
          this.updateMapOptions()
          /* 添加监听，解决设置项不生效的问题 */
          setTimeout(() => {
            this.stop = false
          }, 3000)
        }
      }
    },
    "chartOption.scatter.useScatterClassify"(n, o) {
      /* 添加监听，解决设置项不生效的问题 */
      this.selfChangeData = true
      this.stop = false
      this.updateMapOptions()
    },
    chartOption: {
      deep: true,
      handler(n, o) {
        //改name时 会触发当前watcher，并且这个watcher的执行时机比当前这个watcher考前
        // 这种情况下 在那个watcher内会设置一个变量stop
        //当执行到当前watcher时发先变量stop为true 就不会进行更新
        if (!this.stop) {
          this.updateMapOptions()
        }
      }
    },
    "chartOption.isAutoPlayToolTip": {
      deep: true,
      handler(newVal, oldVal) {
        setTimeout(() => {
          this.autoplayTooltip()
        }, 500)
      }
    },
    "chartOption.autoPlayToolTipIntervalTime": {
      deep: true,
      handler(newVal, oldVal) {
        if (this.isAutoPlayToolTip) {
          setTimeout(() => {
            this.autoplayTooltip()
          }, 500)
        }
      }
    },
    refreshedChart(newVal) {
      if (newVal) {
        this.$refs.map?.setOption(this.getOption)
      } else {
        this.$refs.map?.clear()
      }
    },
  },
  methods: {
    outClick() {
      if (!this.chartOption.deepMap) return
      if (!this.out) {
        //当前点击的不是地图 而是地图旁边的区域
        const name = this.chartOption.name.split("/")
        const from = [this.province, this.city, this.area]
        const start = from.findIndex(item => !item.length)
        if (start === 1 && this.province !== "全国") {
          //当前在省，需要回退到全国
          this.$changeOptionsEV("全国", "chartOption.name", false, null, this.myid, true)
        } else if (start === 2) {
          const provinceCode = this.provinceData.find(item => item.label === name[0]).value
          const dataName = `${name[0]}/${name[0]}.${
            provinceCode + new Array(6 - provinceCode.length).fill("0").join("")
          }`
          this.$changeOptionsEV(dataName, "chartOption.name", false, null, this.myid, true)
          //当前在市，需要回退到省
        } else if (this.province !== "全国") {
          const cityCode = this.cityData.find(item => item.label === name[1]).value
          const dataName = `${name[0]}/${name[1]}/${name[1]}.${
            cityCode + new Array(6 - cityCode.length).fill("0").join("")
          }`
          this.$changeOptionsEV(dataName, "chartOption.name", false, null, this.myid, true)
          //当前在区县 需要回退到市
        }
      } else {
        this.out = false
      }
    },
    initMapJson(name, mode) {
      const mapName = name === "全国" ? "china" : name.split("/").reverse()[0]
      if (name === "全国") {
        this.chinaMapAll = true
      } else {
        this.chinaMapAll = false
      }
      const oldMapData = this.$echarts.getMap(mapName)
      //oldMapData存在,说明之前获取过这个地区的json,就不用获取了
      if (!oldMapData) {
        this.stop = true
        this.instance.get(`sv2/assets/map/mapJSON/${name}.json`).then(res => {
          this.stop = false
          const mapData = res.data
          //将当前新的地图json注册到echarts中
          this.$echarts.registerMap(mapName, mapData)
          this.hasMapJson = true
          this.mapName = mapName
          this.initCenter()
          this.updateMapOptions(mode)
        })
      } else {
        this.stop = false
        this.hasMapJson = true
        this.mapName = mapName
        this.initCenter()
        this.updateMapOptions(mode)
      }
    },
    initCenter() {
      !this.isBigScreenPreview() && this.$changeOptionsEV([107.4, 33.42], "chartOption.center", false, null, this.myid, true)
    },
    async updateMapOptions(mode) {
      if (!this.hasMapJson) {
        return
      }
      const itemStyle = {
        areaColor: this.$parseColor(this.chartOption.areaColor),
        borderColor: this.$parseColor(this.chartOption.primaryBorderColor),
        borderWidth: this.chartOption.primaryBorderWidth
      }
      let tooltip = {
        show: false
      }
      if (this.chartOption.tooltip && this.chartOption.tooltip?.show) {
        let tooltipP = undefined
        if (this.chartOption.tooltip?.tooltipPosition === "fixed") {
          tooltipP = []
          tooltipP.push((this.chartOption.tooltip?.tooltipPositionX || 0) + "%")
          tooltipP.push((this.chartOption.tooltip?.tooltipPositionY || 0) + "%")
        }
        let tooltipPadding = this.chartOption.tooltip?.tooltipPadding || 0
        if (!this.chartOption.tooltip.tooltipPaddingTypeFlag || this.chartOption.tooltip.tooltipPaddingTypeFlag === 2) {
          tooltipPadding = [
            this.chartOption.tooltip?.tooltipPaddingTop || 0,
            this.chartOption.tooltip?.tooltipPaddingRight || 0,
            this.chartOption.tooltip?.tooltipPaddingBottom || 0,
            this.chartOption.tooltip?.tooltipPaddingLeft || 0
          ]
        }
        //  背景添加
        let bgData =
          ";background-color:" +
          this.$parseColor(this.tooltipBgStyle.backgroundColor) +
          ";background-image:" +
          this.tooltipBgStyle.backgroundImage
        if (this.tooltipBgStyle.backgroundPosition) {
          bgData =
            bgData +
            ";background-position:" +
            this.tooltipBgStyle.backgroundPosition +
            ";background-repeat:" +
            this.tooltipBgStyle.backgroundRepeat +
            ";background-size:" +
            this.tooltipBgStyle.backgroundSize
        }

        let toolBoxWidth = 100
        if (this.chartOption.tooltip.tooltipWidth) {
          toolBoxWidth = this.chartOption.tooltip.tooltipWidth
        }
        let boxHeight = 100
        if (this.chartOption.tooltip.tooltipHeight) {
          boxHeight = this.chartOption.tooltip.tooltipHeight
        }
        let fontStr = ""
        // 涟漪层展示弹窗
        let formatterDataNew = this.chartOption.scatter.dataFormatter
        if (
          this.chartOption.showScatter &&
          this.chartOption.scatter.data &&
          formatterDataNew &&
          formatterDataNew.length > 0
        ) {
          this.tooltipAuto = false
        }
        // 涟漪层展示弹窗
        let formatterData1New = this.chartOption.visualMap.dataFormatter
        if (
          this.chartOption.showHot &&
          this.chartOption.visualMap.data &&
          formatterData1New &&
          formatterData1New.length > 0
        ) {
          this.tooltipAuto = false
        }
        if (!this.tooltipAuto) {
          fontStr = "font: unset;"
        }
        let borderTopStr = "",
          borderRightStr = "",
          borderBottomStr = "",
          borderLeftStr = ""
        if (this.chartOption.tooltip.tooltipBorderWidth) {
          let arr = this.chartOption.tooltip.tooltipBorderWidth
          borderTopStr = "border-top-width:" + arr[0] + "px;"
          borderRightStr = "border-right-width:" + arr[1] + "px;"
          borderBottomStr = "border-bottom-width:" + arr[2] + "px;"
          borderLeftStr = "border-left-width:" + arr[3] + "px;"
        }
        tooltip = {
          show: this.chartOption.tooltip?.show || false,
          trigger: "item",
          textStyle: {
            color: this.chartOption.tooltip? this.$parseColor(this.chartOption.tooltip.tooltipFontColor) : "#000",
            fontSize: this.chartOption.tooltip?.tooltipFontSize || 12,
            fontWeight: this.chartOption.tooltip?.tooltipFontWeight || 400,
            fontFamily: this.chartOption.tooltip?.tooltipFontFamily || "sans-serif"
          },
          triggerOn: this.chartOption.tooltip?.tooltipTriggerOn || "mousemove",
          position: tooltipP,
          padding: tooltipPadding,
          borderColor:
              this.$parseColor(this.chartOption.tooltip?.tooltipBorderColor,{isThemeColor:this.chartOption.tooltip?.tooltipBorderIsThemeColor}),
          // borderColor: this.chartOption.tooltip?.tooltipBorderIsThemeColor
          //   ? this.themeColor
          //   : this.chartOption.tooltip.tooltipBorderColor && this.chartOption.tooltip.tooltipBorderColor.color
          //   ? this.chartOption.tooltip.tooltipBorderColor.color
          //   : this.chartOption.tooltip.tooltipBorderColor,
          // borderWidth: this.chartOption.tooltip.tooltipBorderWidth || 0,
          extraCssText:
            "overflow: hidden;border-style: " +
            this.chartOption.tooltip.tooltipBorderStyle +
            bgData +
            ";width: " +
            toolBoxWidth +
            "px;height: " +
            boxHeight +
            "px;box-shadow: none;" +
            fontStr +
            borderTopStr +
            borderRightStr +
            borderBottomStr +
            borderLeftStr,
          renderMode: "html",
          alwaysShowContent: false /*弹窗长显*/,
          showContent: true,
          formatter: params => {
            if (params.data) {
              // 涟漪层展示弹窗
              let formatterData = this.chartOption.scatter.dataFormatter
              // 热力层展示弹窗
              let formatterData1 = this.chartOption.visualMap.dataFormatter
              if (
                this.chartOption.showScatter &&
                this.chartOption.scatter.data &&
                formatterData &&
                formatterData.length > 0
              ) {
                this.list = []
                this.renderFormatterFunc(formatterData, params.data)
                this.tooltipAuto = false
                return this.$refs.tooltip1
              } else if (
                params.componentType === "series" &&
                this.chartOption.showHot &&
                this.chartOption.visualMap.data &&
                formatterData1 &&
                formatterData1.length > 0
              ) {
                let datas = this.chartOption.visualMap.data
                this.list = []
                datas.forEach((item, index) => {
                  if (item.name == params.name) {
                    this.renderFormatterFunc(formatterData1, item)
                  }
                })
                this.tooltipAuto = false
                return this.$refs.tooltip1
              } else {
                this.tooltipAuto = true
                this.tooltipAutoName = params.name
                return params.name
              }
            } else if (params.componentType === "geo") {
              // 热力层展示弹窗
              let formatterData = this.chartOption.visualMap.dataFormatter
              if (
                this.chartOption.showHot &&
                this.chartOption.visualMap.data &&
                formatterData &&
                formatterData.length > 0
              ) {
                let datas = this.chartOption.visualMap.data
                this.list = []
                datas.forEach((item, index) => {
                  if (item.name == params.name) {
                    this.renderFormatterFunc(formatterData, item)
                  }
                })
                this.tooltipAuto = false
                return this.$refs.tooltip1
              } else {
                this.tooltipAuto = true
                this.tooltipAutoName = params.name
                return params.name
              }
            } else {
              this.tooltipAuto = true
              this.tooltipAutoName = params.name
              return params.name
            }
          }
        }
        this.sameChange()
      }
      const series = []
      //散点图样式
      if (this.chartOption.showScatter) {
        let scatterOpt = this.chartOption.scatter
        let seriesArr = {}
        if (scatterOpt.useScatterClassify && scatterOpt.seriesData?.length > 0) {
          for (let i = 0; i < scatterOpt.seriesData.length; i++) {
            let data1 = scatterOpt.seriesData[i]
            seriesArr = this.renderScatterObj(mode, tooltip, data1, false)
            series.push(seriesArr)
          }
        } else {
          seriesArr = this.renderScatterObj(mode, tooltip, scatterOpt, true)
          series.push(seriesArr)
        }
      }
      //飞线图样式
      if (this.chartOption.showLines) {
        const linesOpt = this.chartOption.lines
        const { linesData, centerData } = this.getLinesData(mode)
        let linesData1 = JSON.parse(JSON.stringify(linesData))
        if(linesOpt.effect.hasOwnProperty("symbolDirection") && linesOpt.effect.symbolDirection === "spread"){
          let linesDataCopy = linesData1
          for (let i = 0; i < linesData1.length; i++) {
            let item1 = linesData1[i][0]
            linesDataCopy[i][0] = linesData1[i][1]
            linesDataCopy[i][1] = item1
          }
          linesData1 = linesDataCopy
        }
        series.push(
          {
            type: "lines",
            zlevel: 2,
            animationDuration: 1000,
            effect: {
              show: linesOpt.effect.show,
              period: linesOpt.effect.period, //箭头指向速度，值越小速度越快
              trailLength: linesOpt.effect.trailLength, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: linesOpt.effect.symbol, //箭头图标
              symbolSize: linesOpt.effect.symbolSize //图标大小
            },
            label: {
              show: linesOpt.label.show,
              position: linesOpt.label.position,
              color: this.$parseColor(linesOpt.label.fontColor),
              fontFamily: linesOpt.label.fontFamily,
              fontSize: linesOpt.label.fontSize,
              fontWeight: linesOpt.label.fontWeight,
              formatter: "{c}"
            },
            lineStyle: {
              color: this.$parseColor(linesOpt.lineStyle.color),
              type: linesOpt.lineStyle.type,
              dashOffset: 5,
              // normal: {
              width: linesOpt.lineStyle.width, //尾迹线条宽度
              opacity: 1, //尾迹线条透明度
              curveness: linesOpt.lineStyle.curveness //尾迹线条曲直度
              // }
            },
            data: linesData1,
            tooltip:{
              show: false
            }
          },
          {
            type: "scatter",
            coordinateSystem: "geo",
            zlevel: 2,
            animationDuration: 1000,
            //   rippleEffect: {
            //     period: 4,
            //     brushType: "stroke",
            //     scale: 4
            //   },
            symbolSize: 5,
            data: [
              {
                name: centerData.name,
                value: [...centerData.center].concat([10])
              }
            ]
          }
        )
      }
      const select = {
        itemStyle: {
          areaColor: this.$parseColor(this.chartOption.selectColor),
          borderWidth: this.chartOption.selectBorderWidth,
          borderColor: this.$parseColor(this.chartOption.selectBorderColor)
        },
        label: {
          show: this.chartOption.showLabel,
          color: this.$parseColor(this.chartOption.select.selectFontColor),
          fontSize: this.chartOption.select.selectFontSize,
          fontWeight: this.chartOption.select.selectFontWeight,
          fontFamily: this.chartOption.select.selectFontFamily
        }
      }
      const emphasis = {
        itemStyle: {
          areaColor: this.$parseColor(this.chartOption.selectColor),
          borderWidth: this.chartOption.selectBorderWidth,
          borderColor: this.$parseColor(this.chartOption.selectBorderColor)
        },
        label: {
          show: this.chartOption.showLabel,
          color: this.$parseColor(this.chartOption.select.selectFontColor),
          fontSize: this.chartOption.select.selectFontSize,
          fontWeight: this.chartOption.select.selectFontWeight,
          fontFamily: this.chartOption.select.selectFontFamily
        }
      }
      const label = {
        show: this.chartOption.showLabel,
        color: this.$parseColor(this.chartOption.label.labelFontColor),
        fontSize: this.chartOption.label.labelFontSize,
        fontWeight: this.chartOption.label.labelFontWeight,
        fontFamily: this.chartOption.label.labelFontFamily
      }
      let opt, geoDistance = {}
      if(this.chartOption.isSelfPadding){
        geoDistance = {
          top:this.chartOption.paddingTop || 0,
          right: this.chartOption.paddingRight || 0,
          left: this.chartOption.paddingLeft || 0,
          bottom: this.chartOption.paddingBottom || 0
        }
        if (this.chartOption.paddingTypeFlag === 1) {
          geoDistance = {
            top: this.chartOption.padding || 0,
            right: this.chartOption.padding || 0,
            left: this.chartOption.padding || 0,
            bottom: this.chartOption.padding || 0
          }
        }
      }
      //热力图样式
      if (this.chartOption.showHot) {
        let visualMapOpt = this.chartOption.visualMap ? this.chartOption.visualMap : chartOption1.visualMap
        if (this.chartOption.visualMap == undefined) {
          this.$changeOptionsEV(visualMapOpt, "chartOption.visualMap", false, null, this.myid, true)
        }
        let startColor = this.$parseColor(this.chartOption.visualMap.mapStartColor)
        let endColor = this.$parseColor(this.chartOption.visualMap.mapEndColor)
        const min = this.chartOption.visualMap.min
        let max = this.chartOption.visualMap.max
        if (this.chartOption.visualMap.maxTimes) {
          max = this.chartOption.visualMap.maxTimes * this.chartOption.visualMap.max
        }
        if (startColor[0] !== "#") {
          startColor = this.rgbaToColor(startColor)
        }
        if (endColor[0] !== "#") {
          endColor = this.rgbaToColor(endColor)
        }
        let colorList = this.gradientColors(startColor, endColor, 10)
        const { visualMap } = this.getVisualMapData(mode)
        if(!this.chartOption.showLines){
          series.push({
            type: "map",
            geoIndex: 0,
            data: visualMapOpt.data
          })
        }
        let regions = []
        if (regions.length <= visualMap.length) {
          for (let i = 0; i < visualMap.length; i++) {
            regions.push({
              name: visualMap[i].name,
              itemStyle: {
                areaColor: colorList[this.betweenNubmerIndex(min, max, visualMap[i].value, 10)]
              }
            })
          }
        }
        if (this.chartOption.tooltip && this.chartOption.tooltip?.show) {
          series.push({
            map: this.mapName,
            type: "map",
            zoom: this.chartOption.zoom,
            zlevel: -1,
            geoIndex: 0,
            data: visualMap
          })
        }
        if(!this.chartOption.showLines){
        opt = {
          geo: {
            selectedMode: "single",
            map: this.mapName,
            tooltip,
            zoom: this.chartOption.zoom,
            itemStyle,
            select,
            emphasis,
            label,
            // regions: regions,
            roam: this.chartOption.roam,
            ...geoDistance
          },
          visualMap: {
            top: visualMapOpt.top,
            left: visualMapOpt.left,
            min: min,
            max: max,
            orient: visualMapOpt.orient,
            show: visualMapOpt.show,
            calculable: visualMapOpt.calculable,
            inRange: {
              color: [startColor, endColor]
            },
            type: visualMapOpt.type,
            showLabel: visualMapOpt.textStyle.show,
            text: ["最大值", "最小值"],
            textStyle: {
              show: visualMapOpt.textStyle.show,
              color: this.request_prefix === "bigScreen" ? "white" : "#333",
              fontSize: visualMapOpt.textStyle.show ? 12 : 0,
              lineHeight: 40
            },
            handleIcon: this.VisualMapExampleHandleIcon ? "" : "none",
            textGap: 20,
            seriesIndex: this.chartOption.showScatter ? [1] : [0],
          },
          tooltip,
          series
        }
        }else{
          opt = {
            geo: {
              selectedMode: "single",
              map: this.mapName,
              tooltip,
              zoom: this.chartOption.zoom,
              itemStyle,
              select,
              emphasis,
              label,
              regions: regions,
              roam: this.chartOption.roam,
              ...geoDistance
            },
            tooltip,
            series
          }
        }

      } else {
        opt = {
          geo: {
            selectedMode: "single",
            map: this.mapName,
            tooltip: {
              show: false
            },
            zoom: this.chartOption.zoom,
            itemStyle,
            select,
            emphasis,
            label,
            roam: this.chartOption.roam,
            ...geoDistance,
          },
          tooltip,
          series
        }
      }
      if (this.chinaMapAll) {
        opt.center = this.chartOption.center
      }
      await this.initPlugin(opt)
      //       判断是否有飞线插件
      if(this.chartOption.lines.dataHasZero){
        opt = this.lineDataZeroFunc(opt, this.chartOption.lines.effect.symbolDirection)
      }
      this.created = true
      this.changeName = false
      this.$refs.map.setOption(opt, { notMerge: true })
      this.activeCityOnFirstLoad()
    },
    //渲染散点样式
    renderScatterObj(mode, tooltip, scatterOpt, isDefault) {
      let name = {}
      if (!isDefault) {
        name = {
          name: scatterOpt.name
        }
      }
      return {
        ...name,
        type: "effectScatter",
        coordinateSystem: "geo",
        zlevel: 3,
        showEffectOn: scatterOpt.showEffectOnHover ? "emphasis" : "render",
        animationDuration: 1000,
        color: this.$parseColor(scatterOpt.color),
        rippleEffect: {
          //涟漪特效
          color: isDefault ? this.$parseColor(scatterOpt.rippleEffect.color) :
              this.$parseColor(scatterOpt.rippleEffectColor),
          number: isDefault ? scatterOpt.rippleEffect.number : scatterOpt.rippleEffectNumber,
          period: isDefault ? scatterOpt.rippleEffect.period : scatterOpt.rippleEffectPeriod, //动画时间，值越小速度越快
          brushType: isDefault ? scatterOpt.rippleEffect.brushType : scatterOpt.rippleEffectBrushType, //波纹绘制方式 stroke, fill
          scale: isDefault ? scatterOpt.rippleEffect.scale : scatterOpt.rippleEffectScale //波纹圆环最大限制，值越大波纹越大
        },
        label: {
          show: isDefault ? scatterOpt.label.show : scatterOpt.labelShow,
          color: isDefault ? this.$parseColor(scatterOpt.label.labelFontColor) :
              this.$parseColor(scatterOpt.labelFontColor),
          fontSize: isDefault ? scatterOpt.label.labelFontSize : scatterOpt.labelFontSize,
          fontWeight: isDefault ? scatterOpt.label.labelFontWeight : scatterOpt.labelFontWeight,
          fontFamily: isDefault ? scatterOpt.label.labelFontFamily : scatterOpt.labelFontFamily,
          offset: isDefault ? scatterOpt.label.offset : scatterOpt.labelOffset, //偏移设置
          formatter: "{b}"
        },
        symbol: scatterOpt.symbol,
        symbolSize: scatterOpt.symbolSize,
        data: isDefault ? this.getScatterData(mode) : scatterOpt.data,
        tooltip
      }
    },

    //渲染弹窗的数据格式
    renderFormatterFunc(formatterData, allItem, type) {
      if (!type) {
        this.showTooltipDiv = true
      }
      // 涟漪层加了字段匹配
      for (let i = 0; i < formatterData.length; i++) {
        for (let key in allItem) {
          if (formatterData[i].name == key) {
            let paddingStr = 0,
              marginStr = 0,
              iconMarginStr = 0,
              objNew = {
                name: key,
                value: allItem[key],
                type: formatterData[i].type,
                showLabel: formatterData[i].showLabel
              },
              iconLeftRightStr = 0
            //  内边距
            if (formatterData[i].paddingTypeFlag === 1) {
              paddingStr = formatterData[i].padding + "px"
            } else {
              paddingStr = `${formatterData[i].paddingTop}px  ${formatterData[i].paddingRight}px  ${formatterData[i].paddingBottom}px  ${formatterData[i].paddingLeft}px`
            }
            //  外边距
            if (formatterData[i].marginTypeFlag === 1) {
              marginStr = formatterData[i].margin + "px"
            } else {
              marginStr = `${formatterData[i].marginTop}px  ${formatterData[i].marginRight}px  ${formatterData[i].marginBottom}px  ${formatterData[i].marginLeft}px`
            }
            //  图标外边距
            if (formatterData[i].iconMarginTypeFlag === 1) {
              iconMarginStr = formatterData[i].iconMargin + "px"
              iconLeftRightStr = formatterData[i].iconMargin + formatterData[i].iconMargin
            } else {
              iconMarginStr = `${formatterData[i].iconMarginTop}px  ${formatterData[i].iconMarginRight}px  ${formatterData[i].iconMarginBottom}px  ${formatterData[i].iconMarginLeft}px`
              iconLeftRightStr = formatterData[i].iconMarginRight + formatterData[i].iconMarginLeft
            }
            let iconLeftRightStr1 = (formatterData[i].iconWidth + iconLeftRightStr) + "px"
            if (formatterData[i].type === "1") {
              //文本
              Object.assign(objNew, {
                styleSet: {
                  "text-align": formatterData[i].align,
                  color: this.$parseColor(formatterData[i].fontColor),
                  "font-family": formatterData[i].fontFamily,
                  "font-size": formatterData[i].fontSize + "px",
                  "font-weight": formatterData[i].fontWeight,
                  padding: paddingStr,
                  margin: marginStr,
                  width: formatterData[i].boxWidth + (formatterData[i].boxWidthPercent ? "%" : "px"),
                  height: formatterData[i].boxHeight + (formatterData[i].boxHeightPercent ? "%" : "px"),
                  "background-color": this.$parseColor(formatterData[i].backgroundColor)
                },
                showIcon: formatterData[i].showIcon,
                iconImg: formatterData[i].iconImg,
                iconStyleSet: {
                  width: formatterData[i].iconWidth + "px",
                  height: formatterData[i].iconHeight + "px",
                  "border-raduis": formatterData[i].borderRadius + "px",
                  margin: iconMarginStr
                },
                txtStyleSet: {
                  "max-width": formatterData[i].showIcon ? `calc(100% - ${iconLeftRightStr1})` : "auto"
                },
                labelStyleSet: {
                  color: this.$parseColor(formatterData[i].labelFontColor),
                  "font-family": formatterData[i].labelFontFamily,
                  "font-size": formatterData[i].labelFontSize + "px",
                  "font-weight": formatterData[i].labelFontWeight,
                  "margin-right": formatterData[i].labelMargin + "px"
                },
                showUnit: formatterData[i].showUnit,
                unitValue: formatterData[i].unitValue,
                unitStyleSet: {
                  color:this.$parseColor( formatterData[i].unitFontColor),
                  "font-family": formatterData[i].unitFontFamily,
                  "font-size": formatterData[i].unitFontSize + "px",
                  "font-weight": formatterData[i].unitFontWeight,
                  "margin-left": formatterData[i].unitMargin + "px"
                }
              })
            } else {
              //图片
              Object.assign(objNew, {
                styleSet: {
                  width: formatterData[i].boxWidth + (formatterData[i].boxWidthPercent ? "%" : "px"),
                  height: formatterData[i].boxHeight + (formatterData[i].boxHeightPercent ? "%" : "px"),
                  "text-align": formatterData[i].align,
                  padding: paddingStr,
                  "border-radius": formatterData[i].borderRadius + "px"
                },
                styleSet1: {
                  "border-radius": formatterData[i].borderRadius + "px"
                }
              })
            }
            this.list.push(objNew)
            if (type === 2) {
              this.list1.push(objNew)
            }
          }
        }
      }
    },

    activeCityOnFirstLoad() {
      if (this.isFirst) {
        this.isFirst = false
        const pageQuery =
          this.options?.usePageQuery && sessionStorage.getItem(window.pageQueryUid)?.length
            ? sessionStorage.getItem(window.pageQueryUid)
            : null
        if (pageQuery) {
          this.$refs.map.dispatchAction({
            type: "geoSelect",
            name: pageQuery
          })
        }
      }
    },
    //初始化插件
    async initPlugin(opt) {
      return new Promise(async (resolve, reject) => {
        if (this.chartOption?.pluginNames?.length) {
          const pluginNames = this.chartOption.pluginNames
          for (let i = 0; i < pluginNames.length; i++) {
            if (this[pluginNames[i]]) {
              await this[pluginNames[i]](opt, this)
              resolve()
            } else {
              resolve()
            }
          }
        } else {
          resolve()
        }
      })
    },
    /**
     * @param {string} eventType eventCallbackBus中对应的事件类型
     * @param {object} event echarts的事件传参
     */
    dispatchEventCallback(eventType, event) {
      this.eventCallbackList[eventType]?.forEach(functionName => {
        //函数名带点，说明是插件事件，需要for循环定位到handle
        if (functionName.includes(".")) {
          //如果没找到 说明当前没有注册了这个插件 就不需要执行
          if (
            functionName.indexOf("eventControl") === 0 ||
            (Array.isArray(this.chartOption.pluginNames) &&
              this.chartOption.pluginNames.find(item => functionName.includes(item.slice(0, -6))))
          ) {
            let func = undefined
            let nameSplit = functionName.split(".")
            //将eventCallbackList中对应的时间名字符串拆分后，循环寻址到对应的函数，再执行
            nameSplit.some((tempPointer, pointerIndex) => {
              if (pointerIndex === 0) {
                func = this[tempPointer]
              } else {
                func = func[tempPointer]
              }
              //当找不到当前函数指针对应的函数时，说明当前组件没有用当前插件，则直接return true 跳出循环
              if (!func) {
                return true
              }
            })

            if (func) func(event)
          }
        } else {
          //不带点 说明是公共当方法 没在插件里
          this[functionName](event)
        }
      })
    },
    handleMapDeepEv(event) {
      if (this.area || !this.chartOption.deepMap) return
      this.out = true
      const from = [this.province, this.city, this.area]
      //type === 1 父级是全国或者省级单位
      //type === 2 父级是市级单位
      const cityData = [this.provinceData, this.cityData, this.areaData]
      let name = this.province
      let pcaCode = this.provinceData
      for (let i = 1; i < from.length - 1; i++) {
        let item = from[i]
        if (item.length) {
          name = name + "." + item
        } else break
      }
      name = name.includes("全国") ? event.name : name + "." + event.name
      const namePoint = name.split(".")
      for (let i = 0; i < namePoint.length; i++) {
        if (i + 1 >= namePoint.length) {
          pcaCode = this.province.includes("全国") ? cityData[0] : cityData[i]
        }
      }
      pcaCode = this.province.includes("全国") ? cityData[0] : pcaCode
      // const code = pcaCode.find(item => item.label === name.replaceAll(".", "/").split("/").slice(-1)[0]).value
      // name = `${name.replaceAll(".", "/")}.${new Array(6 - code.length).fill(0).join("")}${code}`
      const pointLen = name.split(".")
      if (pointLen.length === 1) {
        //省
        this.changeProvince(pcaCode.find(item => item.label === pointLen.slice(-1)[0]).value)
        // this.changeProvince()
      } else if (pointLen.length === 2) {
        this.changeCity(pcaCode.find(item => item.label === pointLen.slice(-1)[0]).value)
        //市
      } else if (pointLen.length === 3) {
        this.changeArea(pcaCode.find(item => item.label === pointLen.slice(-1)[0]).value)
        //县
      }
    },
    // 飞线更改地点
    handleMapLineChange(event) {
      if (this.area || this.chartOption.deepMap || !this.chartOption.showLines) return
      let cityName
      let linesData = JSON.parse(JSON.stringify(this.chartOption.lines.data))
      let delIndex = -1
      if (event.componentType === "geo") {
        cityName = event.name
      } else if (event.componentType === "series" && event?.componentSubType === "lines") {
        cityName = event.data.value
        // 判断是否使用了飞线插件
        if(this.chartOption.lines.dataHasZero){
          cityName = event.data.value2
        }
      } else if (event.componentType === "series" && event?.componentSubType === "map") {
        //解决地图热力、涟漪、飞线全部打开，并且打开热力提示框时，点击区域飞线中心变化不生效
        cityName = event.data.name
      }
      const newLineCity = linesData.filter((current, index, arr) => {
        if (current[0].value === cityName) {
          delIndex = index
          return current
        }
      })
      // 首先将这个城市放在第一条，然后删除点击的这个城市
      if (delIndex === -1) return
      linesData.splice(0, 0, newLineCity[0])
      linesData.splice(delIndex + 1, 1)
      for (let i = 0; i < linesData.length; i++) {
        linesData[i][1].coord = newLineCity[0][0].coord
      }
      let newCenterCity = {
        center: [parseFloat(newLineCity[0][0].coord[0]), parseFloat(newLineCity[0][0].coord[1])],
        name: newLineCity[0][0].value
      }
      this.$changeOptionsEV(newCenterCity, "chartOption.lines.centerData", false, null, this.myid, true)
      this.$changeOptionsEV(linesData, "chartOption.lines.data", false, null, this.myid, true)
    },
    // 涟漪层散点点击
    handleMapScatterChange(event) {
      if (this.chartOption.deepMap || !this.chartOption.showScatter) return
      let cityName
     /* if (event.componentType === "geo") {
        cityName = event.name
      } else */
      if (event.componentType === "series" && event?.componentSubType === "effectScatter") {
        cityName = event.data.name
      }
      this.$changeOptionsEV(cityName, "chartOption.scatter.selectName", false, null, this.myid, true)
    },
    changeProvince(provinceCode) {
      if (!provinceCode) {
        this.$changeOptionsEV("全国", "chartOption.name", false, null, this.myid, true)
      } else {
        const name = this.provinceData.find(item => item.value === provinceCode).label
        const jsonLocation = `${name}/${name}.${provinceCode + new Array(6 - provinceCode.length).fill(0).join("")}`
        this.$changeOptionsEV(jsonLocation, "chartOption.name", false, null, this.myid, true)
      }
    },
    changeCity(cityCode) {
      let province = this.pcaCode.find(province => province.name === this.province)
      let specialProvince
      if (province.children.length === 1) {
        //处理直辖市
        specialProvince = 1
        province = province.children[0]
      }
      const city = province.children.find(city => city.code === cityCode)
      const jsonLocation = `${this.province}/${specialProvince ? "" : city.name + "/"}${city.name}.${
        city.code + new Array(6 - city.code.length).fill(0).join("")
      }`
      this.$changeOptionsEV(jsonLocation, "chartOption.name", false, null, this.myid, true)
    },
    changeArea(areaCode) {
      const names = this.chartOption.name.split("/")
      const provinces = this.pcaCode.find(province => province.name === names[0])
      const cities = provinces.children.find(city => city.name === names[1])
      const area = cities.children.find(area => area.code === areaCode)
      const jsonLocation = `${provinces.name}/${cities.name}/${area.name}.${area.code}`
      this.$changeOptionsEV(jsonLocation, "chartOption.name", false, null, this.myid, true)
    },
    reloadChart() {
      this.$nextTick(() => {
        this.showChart = false
        this.$nextTick(() => {
          this.showChart = true
        })
      })
    },
    getScatterData(mode) {
      let stauts1 = !this.chartOption.scatterHasDataUrl
      if(this.changeName){
        stauts1 = true
      }
      if ((!this.stop && this.created && mode && stauts1) || !this.chartOption.scatter.data) {
        this.selfChangeData = true //和主逻辑无关
        const name = this.chartOption.name
        const mapName = name === "全国" ? "china" : name.split("/").reverse()[0]
        const centers = this.$echarts.getMap(mapName).geoJSON.features
        const res = centers
          .map(item => {
            if (item.properties.center) {
              return {
                name: item.properties.name,
                value: item.properties.center.concat(0)
              }
            } else {
              return undefined
            }
          })
          .filter(item => item !== undefined)
        this.$changeOptionsEV(res, "chartOption.scatter.data", false, null, this.myid, true)
      } else {
        this.stop = false //和主逻辑无关
      }
      return this.chartOption.scatter.data
    },
    getHotDa() {
      if ((!this.stop && this.created && mode) || !this.chartOption.hot.data) {
        const data = this.instance.get(this.options.url)
        const res = centers
          .map(item => {
            if (item.properties.center) {
              return {
                name: item.properties.name,
                value: item.properties.center.concat(0)
              }
            } else {
              return undefined
            }
          })
          .filter(item => item !== undefined)
        this.$changeOptionsEV(res, "chartOption.hot.data", false, null, this.myid, true)
      } else {
        this.stop = false //和主逻辑无关
      }
      return this.chartOption.hot.data
    },
    getLinesData(mode) {
      let stauts1 = !this.chartOption.linesHasDataUrl
      if(this.changeName){
        stauts1 = true
      }
      if ((!this.stop && this.created && mode && stauts1) || !this.chartOption.lines.data) {
        this.selfChangeData = true
        const name = this.chartOption.name
        const mapName = name === "全国" ? "china" : name.split("/").reverse()[0]
        const allCity = this.$echarts.getMap(mapName).geoJSON.features
        const centerCode = [...allCity[0].properties.center]
        const geoCoord = allCity
          .map(it => {
            if (
              !it?.properties?.center?.length ||
              (it.properties.center[0] === centerCode[0] && it.properties.center[1] === centerCode[1])
            ) {
              return undefined
            } else {
              return [
                {
                  value: it.properties.name,
                  coord: it.properties.center
                },
                { coord: centerCode }
              ]
            }
          })
          .filter(it => {
            return it !== undefined && it[0].coord
          })
        this.$changeOptionsEV(geoCoord, "chartOption.lines.data", false, null, this.myid, true)
        this.$changeOptionsEV(allCity[0].properties, "chartOption.lines.centerData", false, null, this.myid, true)
        // 补全第一条飞线中心点
        if (
          allCity[allCity.length - 1].properties.name === "" &&
          allCity.length - 1 !== this.chartOption.lines.data.length
        ) {
          let newlinesData = JSON.parse(JSON.stringify(this.chartOption.lines.data))
          newlinesData.unshift([
            {
              value: allCity[0].properties.name,
              coord: allCity[0].properties.center
            },
            {
              coord: allCity[0].properties.center
            }
          ])
          this.$changeOptionsEV(newlinesData, "chartOption.lines.data", false, null, this.myid, true)
        } else if (
          allCity[allCity.length - 1].properties.name !== "" &&
          allCity.length !== this.chartOption.lines.data.length
        ) {
          let newlinesData = JSON.parse(JSON.stringify(this.chartOption.lines.data))
          newlinesData.unshift([
            {
              value: allCity[0].properties.name,
              coord: allCity[0].properties.center
            },
            {
              coord: allCity[0].properties.center
            }
          ])
          this.$changeOptionsEV(newlinesData, "chartOption.lines.data", false, null, this.myid, true)
        }
      } else {
        this.stop = false
      }
      return { linesData: this.chartOption.lines.data, centerData: this.chartOption.lines.centerData }
    },
    getVisualMapData(mode) {
      let stauts1 = !this.chartOption.hotHasDataUrl
      if(this.changeName){
        stauts1 = true
      }
      if ((!this.stop && this.created && mode && stauts1) || !this.chartOption.visualMap.data) {
        this.selfChangeData = true
        const name = this.chartOption.name
        const mapName = name === "全国" ? "china" : name.split("/").reverse()[0]
        const allCity = this.$echarts.getMap(mapName).geoJSON.features
        let maxValue = this.chartOption.visualMap.max
        if (this.chartOption.visualMap.maxTimes) {
          maxValue = this.chartOption.visualMap.maxTimes * this.chartOption.visualMap.max
        }
        const minValue = this.chartOption.visualMap.min
        const res = allCity
          .map(item => {
            if (item.properties.name) {
              return {
                name: item.properties.name,
                value: this.chartOption.hotHasDataUrl ? 0 :this.getRandomValue(maxValue, minValue)
              }
            } else {
              return undefined
            }
          })
          .filter(item => item !== undefined)
        this.$changeOptionsEV(res, "chartOption.visualMap.data", false, null, this.myid, true)
      } else {
        this.stop = false
      }
      return { visualMap: this.chartOption.visualMap.data }
    },
    getRandomValue: function (max, min) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 取两个色之间的色值
    parseColor: function (hexStr) {
      return hexStr.length === 4
        ? hexStr
            .substr(1)
            .split("")
            .map(function (s) {
              return 0x11 * parseInt(s, 16)
            })
        : [hexStr.substr(1, 2), hexStr.substr(3, 2), hexStr.substr(5, 2)].map(function (s) {
            return parseInt(s, 16)
          })
    },
    pad: function (s) {
      return s.length === 1 ? "0" + s : s
    },
    gradientColors: function (start, end, steps, gamma) {
      var i,
        j,
        ms,
        me,
        output = [],
        so = []
      gamma = gamma || 1
      var normalize = function (channel) {
        return Math.pow(channel / 255, gamma)
      }
      start = this.parseColor(start).map(normalize)
      end = this.parseColor(end).map(normalize)
      for (i = 0; i < steps; i++) {
        ms = i / (steps - 1)
        me = 1 - ms
        for (j = 0; j < 3; j++) {
          so[j] = this.pad(Math.round(Math.pow(start[j] * me + end[j] * ms, 1 / gamma) * 255).toString(16))
        }
        output.push("#" + so.join(""))
      }
      return output
    },
    //rgba转16进制
    rgbaToColor: function (color) {
      var values = color
        .replace(/rgba?\(/, "")
        .replace(/\)/, "")
        .replace(/[\s+]/g, "")
        .split(",")
      var a = parseFloat(values[3] || 1),
        r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255),
        g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255),
        b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255)
      return (
        "#" + ("0" + r.toString(16)).slice(-2) + ("0" + g.toString(16)).slice(-2) + ("0" + b.toString(16)).slice(-2)
      )
    },
    betweenNubmerIndex: function (start, end, number, step) {
      const stepNumber = Math.ceil((end - start) / step)
      let index = 0
      for (let i = 0; i < stepNumber; i++) {
        if (number >= start + i * stepNumber && number <= end) {
          index = i
        }
      }
      return index
    },
    getVisualNumberList: function (start, end, step) {
      const stepNumber = Math.ceil((end - start) / step)
      let numList = []
      let endNum = 0
      let startNum = 0
      for (let i = 0; i < step; i++) {
        endNum = stepNumber * (i + 1)
        if (endNum > end) {
          endNum = end
        }
        startNum = stepNumber * i
        numList.push(startNum + "-" + endNum)
      }
      return numList
    },
    // 开启数据轮询后的方法
    async getBaseModuleDataLoop(itemId, type) {
      const swData = getSwData(this.options)
      if (itemId !== -1) {
        let newIds = JSON.parse(JSON.stringify(this.ids))
        //  地图在自由布局中的情况
        if (newIds.uid) {
          delete newIds.uid
        }
        if (newIds.elementInLayoutId || newIds.elementInLayoutId === 0) {
          delete newIds.elementInLayoutId
        }
        newIds.rect_id = itemId
        let component1 = this.getAttrById.call(this, this.$store.state[this.request_prefix], newIds)
        if (!component1) {
          if (type === "line") {
            this.lineMapRectId = -1
          } else if (type === "hot") {
            this.hotMapRectId = -1
          } else if (type === "scatter") {
            this.scatterMapRectId = -1
          }
          return null
        }
        const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], newIds).options
        let { appId } = rectAttr
        if (
          this.restDataUrl &&
          this.restDataUrl.length &&
          this.restDataUrl.slice(this.restDataUrl.indexOf("chart") + 6, -5) !== appId
        ) {
          this.restDataUrl = `engine2/data/api-v2/chart/${appId}/data?sw=` + swData
        } else if (rectAttr.restDataUrl && rectAttr.restDataUrl.length) {
          /* 需求：地图无数据源，特效图有外接数据源情况下的传参 */
          return rectAttr.restDataUrl + "?sw=" + swData
        }
        return this.restDataUrl + "?sw=" + swData
      } else {
        return null
      }
    },
    async getAllMapDataLoop(name) {
      //【地图特效】外接数据源，下钻后返回，有一瞬间闪现默认的涟漪点的问题解决
      if (this.hasMapUrl) {
        this.stop = true
      }
      if (name) this.deepNewName = name === "全国" ? "china" : name.split("/").reverse()[0].split(".")[0]
      const lineDataUrl = await this.getBaseModuleDataLoop(this.lineMapRectId, "line")
      const hotDataUrl = await this.getBaseModuleDataLoop(this.hotMapRectId, "hot")
      const scatterDataUrl = await this.getBaseModuleDataLoop(this.scatterMapRectId, "scatter")
      const { pageId, websiteId } = this.$store.state.states.getDataPageIds
      const wpStr = this.isBigScreenPreview() ? "&w=" + websiteId + "&p=" + pageId : ""
      if (lineDataUrl !== null && lineDataUrl !== "?sw=") {
        try {
          this.instance.get(lineDataUrl + this.deepNewName + wpStr).then(res => {
            allChartDataHandle.handleLineData.call(this, this.options.chartOption, res)
            this.hasMapUrl = true
            this.$changeOptionsEV(true, "chartOption.linesHasDataUrl", false, null, this.myid, true)
          })
        } catch (error) {}
      }
      if (hotDataUrl !== null && hotDataUrl !== "?sw=") {
        try {
          this.instance.get(hotDataUrl + this.deepNewName + wpStr).then(res => {
            allChartDataHandle.handleHotData.call(this, this.options.chartOption, res)
            this.hasMapUrl = true
            this.$changeOptionsEV(true, "chartOption.hotHasDataUrl", false, null, this.myid, true)
          })
        } catch (error) {}
      }
      if (scatterDataUrl !== null && scatterDataUrl !== "?sw=") {
        try {
          this.instance.get(scatterDataUrl + this.deepNewName + wpStr).then(res => {
            allChartDataHandle.handleScatterData.call(this, this.options.chartOption, res)
            this.hasMapUrl = true
            this.$changeOptionsEV(true, "chartOption.scatterHasDataUrl", false, null, this.myid, true)
          })
        } catch (error) {}
      }
    },
    async updateData() {
      this.getAllMapDataLoop()
      this.updateMapOptions()
    },
    autoplayTooltip() {
      clearInterval(this.autoPlayToolTipTimer)
      this.autoPlayToolTipTimer = null
      if (!this.chartOption.tooltip.show || !this.chartOption.isAutoPlayToolTip) {
        return
      }
      let seriesIndex = 0,
        seiresAll = 1
      if (this.chartOption.showScatter) {
        this.tooltipDataLength = this.chartOption.scatter.data.length
        //散点分组
        if (this.chartOption.scatter.useScatterClassify && this.chartOption.scatter.seriesData.length > 1) {
          seiresAll = this.chartOption.scatter.seriesData.length
        }
      }
      if (this.chartOption.showHot) {
        this.tooltipDataLength = this.chartOption.visualMap.data.length
      }
      // 自动播放 tooltip 初始化
      let myChart = this.$refs.map?.chart
      if (this.tooltipDataLength === 0) {
        return
      }
      // 页面进入弹窗需要立即展示，解决间隔时间过长第一次展示太慢的问题
      setTimeout(()=>{
        if (this.chartOption.showScatter) {
          if (this.chartOption.showScatter) {
            myChart._api.dispatchAction({
              type: "showTip",
              seriesIndex: seriesIndex,
              dataIndex: this.tooltipIndex
            })
            //先取消所有的高亮
            myChart._api.dispatchAction({
              type: "downplay",
              seriesIndex: seriesIndex
            })
            myChart._api.dispatchAction({
              type: "highlight",
              seriesIndex: seriesIndex,
              dataIndex: this.tooltipIndex
            })
          } else {
            if (this.chartOption.tooltip?.tooltipPosition === "fixed") {
              myChart._api.dispatchAction({
                type: "showTip",
                seriesIndex: 0,
                dataIndex: this.tooltipIndex
              })
            } else {
              myChart._api.dispatchAction({
                type: "showTip",
                seriesIndex: 0,
                dataIndex: this.tooltipIndex,
                position: function (point) {
                  return [point[0], point[1]]
                }
              })
            }
          }

          this.tooltipIndex++
          if (seiresAll > 1) {
            this.tooltipDataLength = this.chartOption.scatter.seriesData[seriesIndex].data.length
          }
          if (this.tooltipIndex > this.tooltipDataLength - 1) {
            this.tooltipIndex = 0
            if (seiresAll > 1) {
              if (seriesIndex < seiresAll - 1) {
                seriesIndex++
              } else {
                seriesIndex = 0
              }
            }
          }
        }
      }, 500)

      if (!this.chartOption.autoPlayToolTipIntervalTime) {
        this.chartOption.autoPlayToolTipIntervalTime = 1000
      }
      this.autoPlayToolTipTimer = setInterval(() => {
        if (this.chartOption.showScatter) {
          myChart._api.dispatchAction({
            type: "showTip",
            seriesIndex: seriesIndex,
            dataIndex: this.tooltipIndex
          })
          //先取消所有的高亮
          myChart._api.dispatchAction({
            type: "downplay",
            seriesIndex: seriesIndex
          })
          myChart._api.dispatchAction({
            type: "highlight",
            seriesIndex: seriesIndex,
            dataIndex: this.tooltipIndex
          })
        } else {
          if (this.chartOption.tooltip?.tooltipPosition === "fixed") {
            myChart._api.dispatchAction({
              type: "showTip",
              seriesIndex: 0,
              dataIndex: this.tooltipIndex
            })
          } else {
            myChart._api.dispatchAction({
              type: "showTip",
              seriesIndex: 0,
              dataIndex: this.tooltipIndex,
              position: function (point) {
                return [point[0], point[1]]
              }
            })
          }
        }

        this.tooltipIndex++
        if (seiresAll > 1) {
          this.tooltipDataLength = this.chartOption.scatter.seriesData[seriesIndex].data.length
        }
        if (this.tooltipIndex > this.tooltipDataLength - 1) {
          this.tooltipIndex = 0
          if (seiresAll > 1) {
            if (seriesIndex < seiresAll - 1) {
              seriesIndex++
            } else {
              seriesIndex = 0
            }
          }
        }
      }, this.chartOption.autoPlayToolTipIntervalTime)
    },
    sameChange() {
      // 热力层展示弹窗
      let formatterData = this.chartOption.visualMap.dataFormatter
      if (this.chartOption.showHot && this.chartOption.visualMap.data && formatterData && formatterData.length > 0) {
        let datas = this.chartOption.visualMap.data
        this.list1 = []
        this.renderFormatterFunc(formatterData, datas[0], 2)
      }
      // 涟漪层展示弹窗
      let formatterData1 = this.chartOption.scatter.dataFormatter
      if (
        this.chartOption.showScatter &&
        this.chartOption.scatter.data &&
        formatterData1 &&
        formatterData1.length > 0
      ) {
        this.list1 = []
        this.renderFormatterFunc(formatterData1, this.chartOption.scatter.data[0], 2)
      }
    },
    handleMapRegionEv(event) {
      //地图区域点击事件，不打开特效下有用：实现交互事件点击区域传参
      if (
        this.chartOption.deepMap &&
        this.chartOption.showLines &&
        this.chartOption.showScatter &&
        this.chartOption.showHot
      )
        return
      this.$changeOptionsEV(event.name, "chartOption.regionName", false, null, this.myid, true)
    }
  },
  computed: {
    ids() {
      return this.myid
    },

    getChartStyle() {
      return {
        height: "100%",
        ...this.getChartCommonStyle
      }
    },
    chartOption() {
      return this.options.chartOption
    },
    showHotExample() {
      return this.options.chartOption.showHot
    },
    getVisualMapExampleStyle() {
      if (!this.options.chartOption.showHot) {
        return {}
      } else {
        return {
          display: this.options.chartOption.visualMap.show ? "block" : "none",
          position: "absolute",
          left: this.options.chartOption.visualMap.left + "px",
          top: this.options.chartOption.visualMap.top + "px"
        }
      }
    },
    VisualMapExampleType() {
      return this.options.chartOption.visualMap.type
    },
    VisualMapExampleOrient() {
      return this.options.chartOption.visualMap.orient
    },
    VisualMapExampleHandleIcon() {
      return this.options.chartOption.visualMap.showHandleIcon
    },
    VisualMapExampleText() {
      return this.options.chartOption.visualMap.textStyle.show
    },
    getVisualMapLineStyle() {
      return {
        backgroundImage:
          "linear-gradient(to right," +
            this.$parseColor(this.options.chartOption.visualMap.mapStartColor) +
          " ," +
            this.$parseColor(this.options.chartOption.visualMap.mapEndColor) +
          ")"
      }
    },
    getVisualMapLineVerStyle() {
      return {
        backgroundImage:
          "linear-gradient(to bottom," +
            this.$parseColor(this.options.chartOption.visualMap.mapStartColor) +
          " ," +
            this.$parseColor(this.options.chartOption.visualMap.mapEndColor) +
          ")"
      }
    },
    VisualMapMin() {
      return this.options.chartOption.visualMap.min
    },
    VisualMapMax() {
      let maxVal = this.options.chartOption.visualMap.max
      if (this.options.chartOption.visualMap.maxTimes) {
        maxVal = maxVal * this.options.chartOption.visualMap.maxTimes
      }
      return maxVal
    },
    leftAngleStyle() {
      return {
        borderRightColor: this.$parseColor(this.options.chartOption.visualMap.mapStartColor)
      }
    },
    rightAngleStyle() {
      return {
        borderLeftColor: this.$parseColor(this.options.chartOption.visualMap.mapEndColor)
      }
    },
    rightVerAngleStyle() {
      return {
        borderRightColor: this.$parseColor(this.options.chartOption.visualMap.mapEndColor)
      }
    },
    visualColorList() {
      let startColor = this.$parseColor(this.chartOption.visualMap.mapStartColor)
      let endColor = this.$parseColor(this.chartOption.visualMap.mapEndColor)
      if (startColor[0] !== "#") {
        startColor = this.rgbaToColor(startColor)
      }
      if (endColor[0] !== "#") {
        endColor = this.rgbaToColor(endColor)
      }
      let colorList = this.gradientColors(startColor, endColor, 10)
      let min = this.chartOption.visualMap.min
      let max = this.chartOption.visualMap.max
      if (this.chartOption.visualMap.maxTimes) {
        max = this.chartOption.visualMap.maxTimes * this.chartOption.visualMap.max
      }
      let visualNumberList = this.getVisualNumberList(min, max, 10)
      let allColorList = []
      for (let i = 0; i < 10; i++) {
        allColorList.push({
          color: colorList[i],
          range: visualNumberList[i]
        })
      }
      return allColorList
    },
    updateTimer() {
      if (!this.options.updateTimer) {
        this.$changeOptionsEV(600, "updateTimer", false, null, this.myid, true)
        return 600 * 1000
      }
      return this.options.updateTimer * 1000
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl !== "" ? this.options.restDataUrl : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false, null, this.myid, true)
      }
    },
    lineMapRectId: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lineMapRectId", "lineMapRectId", -1)
      },
      set(val) {
        this.$changeOptionsEV(val, "lineMapRectId", false, null, this.myid, true)
      }
    },
    hotMapRectId: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hotMapRectId", "hotMapRectId", -1)
      },
      set(val) {
        this.$changeOptionsEV(val, "hotMapRectId", false, null, this.myid, true)
      }
    },
    scatterMapRectId: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "scatterMapRectId", "scatterMapRectId", -1)
      },
      set(val) {
        this.$changeOptionsEV(val, "scatterMapRectId", false, null, this.myid, true)
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    isAutoPlayToolTip() {
      return this.options.chartOption.isAutoPlayToolTip
    },
    tooltipBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let hasOldData = false,
        hasNewData = true
      //兼容以前旧数据
      if (this.chartOption.tooltip.show && this.chartOption.tooltip.tooltipBackgroundColor) {
        hasOldData = true
      }
      if (!this.chartOption.tooltipBackgroundColor || !Array.isArray(this.chartOption.tooltipBackgroundColor)) {
        hasNewData = false
        if (!hasOldData) {
          return {}
        }
      }
      let bgArr = this.chartOption.tooltipBackgroundColor
      if (hasOldData && !hasNewData) {
        bgArr = this.chartOption.tooltip.tooltipBackgroundColor
      }
      bgArr.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = bg.clipSize
            containerBg.backgroundPosition = bg.alignType
            containerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            // let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot +  this.$parseColor(bg)
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
            }
            break
          case "radialGradient":
            // let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot +  this.$parseColor(bg)
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
            }
            break
          default:
        }
      })
      return containerBg
    },
    tooltipFixStyle() {
      let toolBoxWidth = 100
      if (this.chartOption.tooltip.tooltipWidth) {
        toolBoxWidth = this.chartOption.tooltip.tooltipWidth
      }

      let boxHeight = 100
      if (this.chartOption.tooltip.tooltipHeight) {
        boxHeight = this.chartOption.tooltip.tooltipHeight
      }
      let tooltipPadding = this.chartOption.tooltip.tooltipPadding + "px" || 0
      if (!this.chartOption.tooltip.tooltipPaddingTypeFlag || this.chartOption.tooltip.tooltipPaddingTypeFlag === 2) {
        tooltipPadding = `${this.chartOption.tooltip.tooltipPaddingTop || 0}px  ${
          this.chartOption.tooltip.tooltipPaddingRight || 0
        }px  ${this.chartOption.tooltip.tooltipPaddingBottom || 0}px  ${
          this.chartOption.tooltip.tooltipPaddingLeft || 0
        }px`
      }
      let borderTopStr = 0,
        borderRightStr = 0,
        borderBottomStr = 0,
        borderLeftStr = 0
      if (this.chartOption.tooltip.tooltipBorderWidth) {
        let arr = this.chartOption.tooltip.tooltipBorderWidth
        borderTopStr = arr[0]
        borderRightStr = arr[1]
        borderBottomStr = arr[2]
        borderLeftStr = arr[3]
      }
      return {
        width: toolBoxWidth + "px",
        height: boxHeight + "px",
        color: this.$parseColor(this.chartOption.tooltip.tooltipFontColor) || "#000",
        "font-size": (this.chartOption.tooltip.tooltipFontSize || 12) + "px",
        "font-weight": this.chartOption.tooltip.tooltipFontWeight || 400,
        "font-family": this.chartOption.tooltip.tooltipFontFamily || "sans-serif",
        padding: tooltipPadding,
        "border-color": this.$parseColor( this.chartOption.tooltip?.tooltipBorderColor,{isThemeColor:
          this.chartOption.tooltip?.tooltipBorderIsThemeColor}),
        "border-top-width": borderTopStr + "px",
        "border-right-width": borderRightStr + "px",
        "border-bottom-width": borderBottomStr + "px",
        "border-left-width": borderLeftStr + "px",
        "border-style": this.chartOption.tooltip.tooltipBorderStyle
          ? this.chartOption.tooltip.tooltipBorderStyle
          : "solid"
      }
    },
    tooltipChartStyle() {
      let paddingWidth = this.chartOption.tooltip.tooltipPadding * 2
      let paddingHeight = this.chartOption.tooltip.tooltipPadding * 2
      if (!this.chartOption.tooltip.tooltipPaddingTypeFlag || this.chartOption.tooltip.tooltipPaddingTypeFlag === 2) {
        paddingWidth = this.chartOption.tooltip.tooltipPaddingRight + this.chartOption.tooltip.tooltipPaddingLeft
        paddingHeight = this.chartOption.tooltip.tooltipPaddingTop + this.chartOption.tooltip.tooltipPaddingBottom
      }
      return {
        "--paddingWidth": "calc(100% - " + paddingWidth + "px)",
        "--paddingHeight": "calc(100% - " + paddingHeight + "px)"
      }
    }
  },
  created() {
    if (!this.chartOption.tooltip) {
      this.chartOption.tooltip = {
        show: false
      }
    }
  },
  mounted() {
    this.initMapJson(this.options.chartOption.name, true)
    this.updateData()
    if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
      this.reloadTimer = setInterval(() => {
        this.updateData()
      }, this.updateTimer + Math.floor(Math.random() * 5000))
    }
    this.autoplayTooltip()
  },
  destroyed() {
    clearInterval(this.reloadTimer)
    this.reloadTimer = null
    clearInterval(this.autoPlayToolTipTimer)
    this.autoPlayToolTipTimer = null
  }
}
</script>

<style scoped>
.visualMapTxt {
  color: #fff;
  font-size: 12px;
}
.centerLineBox {
  position: relative;
  margin: 0 16px;
  width: 100px;
  height: 12px;
}
.visualMapColor {
  display: block;
  width: 100px;
  height: 12px;
}
.left-angle {
  position: absolute;
  top: 12px;
  left: -24px;
  width: 0px;
  height: 0px;
  border-left: 12px solid transparent;
  border-top: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 0px solid transparent;
}
.right-angle {
  position: absolute;
  top: 12px;
  right: -24px;
  width: 0px;
  height: 0px;
  border-left: 12px solid transparent;
  border-top: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 0px solid transparent;
}
.horConBox {
  position: relative;
}
.numberAndAngle {
  position: absolute;
  color: #fff;
  font-size: 12px;
}
.minNumber {
  top: 20px;
  left: 10px;
}
.maxNumber {
  top: 20px;
  right: 10px;
}
.horVerBox {
  position: relative;
}
.horVerBox .centerLineBox {
  position: relative;
  display: block;
  margin: 16px 0px;
  width: 12px;
  height: 100px;
}
.horVerBox .visualMapColor {
  margin-left: 12px;
  width: 12px;
  height: 100px;
}
.horVerBox .minNumber {
  left: 40px;
}
.horVerBox .maxNumber {
  top: auto;
  bottom: 20px;
  left: 40px;
}
.horVerBox .left-angle {
  top: -12px;
  left: 12px;
}
.horVerBox .right-angle {
  bottom: -12px;
  left: 12px;
  top: auto;
  right: auto;
  border-left: 12px solid transparent;
  border-top: 0px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid transparent;
}
.pieColorBox .color-module {
  margin-right: 6px;
  display: inline-block;
  width: 20px;
  height: 14px;
  border-radius: 4px;
}
.pieColorBox .pieColorItem {
  margin-bottom: 4px;
  line-height: 18px;
  height: 18px;
}
.pieColorBox .color-txt {
  color: #fff;
  font-size: 12px;
}

.horPieBox .color-txt {
  display: inline-block;
  white-space: nowrap;
  width: 70px;
}
.horPieBox .pieColorItem {
  display: inline-block;
  vertical-align: top;
  margin-right: 6px;
  margin-bottom: 0;
}
.tooltip-info {
  position: absolute;
  white-space: normal;
  width: 100%;
  width: var(--paddingWidth);
  height: var(--paddingHeight);
}
.tooltip-info-fix li,
.tooltip-info li {
  white-space: normal;
  word-break: break-all;
}
.tooltip-info-fix li img,
.tooltip-info li img {
  width: 100%;
  height: 100%;
}
.tooltip-info-fix {
  position: fixed;
  top: 0;
  z-index: 9999999;
  overflow: hidden;
}
.tooltip-info-fix li div > span,
.tooltip-info li div > span{
  display: inline-block;
  vertical-align: top;
}
.noWrap {
  white-space: nowrap;
}
.opacity0 {
  opacity: 0;
  display: none;
}
.verticallyMiddle {
  vertical-align: middle;
  display: inline-block;
}
.height100 {
  height: 100%;
}
</style>
